import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useBrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import {
  PATH_MY_RESOURCES,
  PATH_MY_RESOURCES_CANCELLATION,
  PATH_MY_RESOURCES_DETAILS,
  PATH_MY_RESOURCES_DETAILS_HISTORY,
  PATH_MY_RESOURCES_PERSONAL_INSURANCE_DETAILS,
  PATH_MY_RESOURCES_REDIRECT_TO_DETAILS_FROM_ENROLLMENT,
  PATH_MY_RESOURCES_TABS,
  PATH_MY_RESOURCES_TABS_DETAILS,
  PATH_MY_RESOURCES_TABS_DETAILS_HISTORY
} from "./paths";
import { RouteMyResourcesDashboard } from "./routes/RouteMyResourcesDashboard";
import { RouteMyResourceDetails } from "./routes/RouteMyResourceDetails";
import { RouteMyResourceHistory } from "./routes/RouteMyResourceHistory";
import { RouteSubmitCancellationFlow } from "./routes/RouteSubmitCancelationFlow";
import { RouteMyRedirectFromEnrollmentToDetails } from "./routes/RouteMyRedirectFromEnrollmentToDetails";
import { RoutePersonalInsurancePolicyDetails } from "./routes/RoutePersonalInsurancePolicyDetails";

export const MyResourcesIndex: React.FC = () => {
  useBrowserPageTitle("My resources");

  return (
    <Switch>
      <Route
        path={PATH_MY_RESOURCES_REDIRECT_TO_DETAILS_FROM_ENROLLMENT}
        component={RouteMyRedirectFromEnrollmentToDetails}
      />

      <Route
        path={PATH_MY_RESOURCES_CANCELLATION}
        component={RouteSubmitCancellationFlow}
      />

      <Route
        path={[
          PATH_MY_RESOURCES_DETAILS_HISTORY,
          PATH_MY_RESOURCES_TABS_DETAILS_HISTORY
        ]}
        component={RouteMyResourceHistory}
      />

      <Route
        path={PATH_MY_RESOURCES_PERSONAL_INSURANCE_DETAILS}
        component={RoutePersonalInsurancePolicyDetails}
      />

      <Route
        path={[PATH_MY_RESOURCES_DETAILS, PATH_MY_RESOURCES_TABS_DETAILS]}
        component={RouteMyResourceDetails}
      />
      <Route
        path={[PATH_MY_RESOURCES, PATH_MY_RESOURCES_TABS]}
        component={RouteMyResourcesDashboard}
      />

      <Redirect from="*" to={PATH_MY_RESOURCES} />
    </Switch>
  );
};
